export default __webpack_public_path__ + "static/media/sergio.6931a23c.png";